export default __webpack_public_path__ + "images/Image10.jpg";